var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ScNavigationItem',{key:_vm.item.id,staticClass:"menu-item-mobile",attrs:{"title":_vm.item.fields.title,"link":_vm.item.fields.link},on:{"clicked:title":function($event){return _vm.handleClick(_vm.item.id)}}})}
var staticRenderFns = []

export { render, staticRenderFns }